(() => {
    if (window.__cartRecsInit) return;
    window.__cartRecsInit = true;

    let cache = { key: '', list: [] };
    let busy = false;
    let again = false;
    let timer;

    const esc = (s) =>
      String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const money = (cents) =>
      (cents / 100).toLocaleString('en-PK', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR',
        maximumFractionDigits: 0,
      });

    const imgUrl = (p) => {
      let src = p.featured_image;
      if (src && typeof src === 'object') src = src.src || src.url;
      if (!src && p.images && p.images.length) {
        src = typeof p.images[0] === 'object' ? p.images[0].src : p.images[0];
      }
      if (!src) return '';
      if (src.startsWith('//')) src = 'https:' + src;
      return src;
    };

    function render(wrap) {
      const track = wrap.querySelector('.cart-recs__track');
      if (!cache.list.length) { wrap.hidden = true; return; }

      if (track.children.length !== cache.list.length) {
        track.innerHTML = cache.list
          .map(
            (p) => `
          <a class="cart-recs__item" href="${p.url}">
            <img src="${imgUrl(p)}" alt="${esc(p.title)}" width="64" height="64">
            <div>
              <div class="cart-recs__name">${esc(p.title)}</div>
              <div class="cart-recs__price">
                ${money(p.price)}
                ${p.compare_at_price > p.price ? `<s>${money(p.compare_at_price)}</s>` : ''}
              </div>
            </div>
          </a>`
          )
          .join('');
      }
      wrap.hidden = false;
    }

    async function update() {
      if (busy) { again = true; return; }
      const wraps = [...document.querySelectorAll('.cart-recs')];
      if (!wraps.length) return;

      // The full cart page has its own recommendations section, so only use the drawer.
      if (window.location.pathname.replace(/\/+$/, '').endsWith('/cart')) {
        wraps.forEach((w) => (w.hidden = true));
        return;
      }

      busy = true;
      try {
        const cart = await fetch('/cart.js').then((r) => r.json());

        if (!cart.items.length) {
          cache = { key: '', list: [] };
          wraps.forEach((w) => (w.hidden = true));
          return;
        }

        const key = cart.items.map((i) => i.product_id).join(',');
        if (cache.key !== key) {
          const inCart = new Set(cart.items.map((i) => i.product_id));
          const res = await fetch(
            `/recommendations/products.json?product_id=${cart.items[0].product_id}&limit=8&intent=related`
          );
          const { products } = await res.json();
          cache = { key, list: products.filter((p) => !inCart.has(p.id)).slice(0, 6) };
        }

        wraps.forEach(render);
      } catch (e) {
        wraps.forEach((w) => (w.hidden = true));
      } finally {
        busy = false;
        if (again) { again = false; schedule(); }
      }
    }

    const schedule = () => {
      clearTimeout(timer);
      timer = setTimeout(update, 300);
    };

    // Arrow buttons
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-recs__arrow');
      if (!btn) return;
      const track = btn.closest('.cart-recs__wrap').querySelector('.cart-recs__track');
      track.scrollBy({ left: track.clientWidth * Number(btn.dataset.dir), behavior: 'smooth' });
    });

    // Horizon morphs the drawer after cart changes, which can clear the slider,
    // so re-render it whenever it goes missing or the cart updates.
    new MutationObserver(() => {
      const wraps = document.querySelectorAll('.cart-recs');
      const needs = [...wraps].some((w) => w.hidden || !w.querySelector('.cart-recs__item'));
      if (needs) schedule();
    }).observe(document.body, { childList: true, subtree: true });

    // Re-check after any add / change / update / clear request to the cart,
    // so the slider appears right after "Add to cart" without a page reload.
    const origFetch = window.fetch;
    window.fetch = function (...args) {
      const p = origFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(() => [300, 900, 2000].forEach((ms) => setTimeout(schedule, ms))).catch(() => {});
        }
      } catch (e) {}
      return p;
    };

    document.addEventListener('cart:update', schedule);
    document.addEventListener('DOMContentLoaded', schedule);
  })();
